import {t} from "i18next";

export default function calculateAge( birthDay, deathDay ){
    const oneYearInMilliseconds = 31556952000
    const oneMonthInMilliseconds = 2629746000
    const oneWeekInMilliseconds = 604800000
    const oneDayInMilliseconds = 86400000

    const dateBirthDay = birthDay;
    const dateNow = deathDay || new Date();
    let diffInMilliseconds = dateNow.getTime() - dateBirthDay.getTime();

    const year = Math.floor(diffInMilliseconds / oneYearInMilliseconds)
    diffInMilliseconds -= year * oneYearInMilliseconds

    const month =  Math.floor(diffInMilliseconds / oneMonthInMilliseconds)
    diffInMilliseconds -= month * oneMonthInMilliseconds

    const week =  Math.floor(diffInMilliseconds / oneWeekInMilliseconds)
    diffInMilliseconds -= week * oneWeekInMilliseconds

    const day =  Math.floor(diffInMilliseconds / oneDayInMilliseconds)

    if(year){
        return `${year} ${t("y.o.")}`
    }

    if(month){
        return `${month} ${t("m.")}`
    }

    if(week){
        return `${week} ${t("w.")}`
    }

    if(day){
        return `${day} ${t("d.")}`
    }

    return null
}
